import { render, staticRenderFns } from "./ScoreIndicator.vue?vue&type=template&id=8334509a"
import script from "./ScoreIndicator.vue?vue&type=script&lang=js"
export * from "./ScoreIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports